<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import http from './api/http'
export default {
  name: 'App',
  mounted() {
    http.get("api/SysInitialize/SysBase").then(result => {
      this.$store.commit('setConfig',result.sysConfig);
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue